import { Box } from '@mui/material';
import TurnstileWidget from './TurnstileWidget';

export const HoneypotField = ({ value, onChange }) => (
    <Box
        aria-hidden="true"
        sx={{ position: 'absolute', left: '-10000px', width: 1, height: 1, overflow: 'hidden' }}
    >
        <label>
            Sitio web
            <input
                name="website"
                type="text"
                value={value}
                onChange={onChange}
                tabIndex={-1}
                autoComplete="off"
            />
        </label>
    </Box>
);

const PublicFormProtection = ({
    website,
    onWebsiteChange,
    captchaRequired,
    captchaKey,
    action,
    onVerify
}) => (
    <>
        <HoneypotField value={website} onChange={onWebsiteChange} />
        {captchaRequired && (
            <TurnstileWidget key={captchaKey} action={action} onVerify={onVerify} />
        )}
    </>
);

export default PublicFormProtection;
